import { FormItem } from "./FormItem";

export class Bool extends FormItem {

    public getType() { return "Bool"; }

    public getValue(): string {
        const el = this.getElement() as HTMLElement;
        const input = el ? el.querySelector("input[type='checkbox']") as HTMLInputElement : null;
        return (input && input.checked) ? "1" : "";
    }

    public reset(): void {
        this.setState("idle");
        const el = this.getElement() as HTMLElement;
        const input = el ? el.querySelector("input[type='checkbox']") as HTMLInputElement : null;
        if (input) { input.checked = false; }
    }

    protected createSelf(): void {
        const name    = (this.get("name")        as string) || "";
        const label   = (this.trans("label")     as string) || "";
        const checked = !!(this.get("checked"));
        const rules   = this.getValidationRules();

        // Renderer headless (bare) : checkbox nue — le label du mockup qui
        // entoure/précède l'input est préservé dans le DOM par la substitution
        // in place du converter, le reconstruire ici le dupliquerait.
        const renderer = this.getRenderer();
        if (renderer.renderBool) {
            const t = renderer.renderBool({
                id:       this.getId() || "fi" + name,
                name,
                checked,
                required: !!(rules && rules.required),
            });
            this.setElement(t.getElement());
            return;
        }

        const el = document.createElement("div");
        el.className = "checkbox-field formi";
        el.setAttribute("formi", "1");
        el.setAttribute("id", "fi" + name);

        const input = document.createElement("input");
        input.type = "checkbox";
        input.id   = name;
        input.name = name;
        // ft/n/info vont sur l'INPUT (descendant) : la résolution de type
        // (createController) et du nom (getAttr via [info]) cherchent en
        // querySelector — un ft posé sur la racine rendait l'item invisible
        // à la collecte : checkbox cochée mais absente du payload.
        input.setAttribute("ft", "bool");
        input.setAttribute("n", name);
        input.setAttribute("info", "1");
        if (rules?.required) { input.required = true; }
        if (checked)         { input.checked  = true; }

        const lbl = document.createElement("label");
        lbl.className = "checkbox-label";
        lbl.setAttribute("for", name);
        lbl.innerHTML = label;

        el.appendChild(input);
        el.appendChild(lbl);

        this.setElement(el);
    }
}
